import React, { type ComponentProps } from 'react';
import { MainTabBar as MainTabBarBase } from '@sg/garnish';

import { useA11ySelector } from '@order/utils';

import { useHasUnseenChallenges } from '../../hooks';
import { type MainTabName } from '../../navigation/AppNavigation.props';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Wrapper around garnish's MainTabBar.
 */
export const MainTabBar = (props: MainTabBarProps) => {
  const a11ySelector = useA11ySelector('tab-bar.container');
  const hasUnseenChallenges = useHasUnseenChallenges();

  // ─────────────────────────────────────────────────────────────────────

  // NOTE: Adds challenges feature flag check + badge.
  const tabsDisplayingBadge: MainTabNames = hasUnseenChallenges
    ? ['LoyaltyTab']
    : [];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <MainTabBarBase
      tabsDisplayingBadge={tabsDisplayingBadge}
      maxFontSizeMultiplier={1.1}
      hiddenTabs={['AccountTab']}
      {...a11ySelector.props}
      {...props}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type MainTabNames = readonly MainTabName[];

type MainTabBarProps = Omit<
  ComponentProps<typeof MainTabBarBase>,
  'hiddenTabs' | 'tabsDisplayingBadge'
>;
